import { useState } from 'react';
import type { TeacherLessonWeek } from '@/features/teacher/types';
const fields = [
  ['lecture_title', 'Название лекции'],
  ['lecture_description', 'Описание лекции'],
  ['practice_title', 'Название практики'],
  ['practice_description', 'Описание практики'],
  ['sro_title', 'Название СРО'],
  ['sro_description', 'Задание СРО'],
  ['sro_deadline', 'Срок СРО'],
  ['srop_title', 'Название СРОП'],
  ['srop_description', 'Задание СРОП'],
  ['srop_window', 'Окно консультации СРОП'],
] as const;
export function CourseLessonEditor({
  code,
  week,
  onSave,
}: {
  code: string;
  week: Partial<TeacherLessonWeek>;
  onSave: (
    payload: Partial<TeacherLessonWeek> & { discipline_code: string; week_number: number },
  ) => Promise<void>;
}) {
  const [values, setValues] = useState<Record<string, string>>(() =>
    Object.fromEntries(fields.map(([field]) => [field, week[field] || ''])),
  );
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  return (
    <details className="text-sm">
      <summary>Редактировать занятие недели {week.week_number}</summary>
      {error && <p role="alert">{error}</p>}
      {fields.map(([field, label]) => (
        <label key={field} className="block">
          {label}
          <textarea
            className="block w-full bg-slate-900 text-white border border-slate-700"
            aria-label={label}
            value={values[field]}
            onChange={(e) => setValues((prev) => ({ ...prev, [field]: e.target.value }))}
          />
        </label>
      ))}
      <button
        disabled={saving}
        onClick={() => {
          setSaving(true);
          void onSave({
            ...values,
            discipline_code: code,
            week_number: week.week_number || 1,
            publication_status: 'Черновик',
          })
            .catch((e) => setError(e.message))
            .finally(() => setSaving(false));
        }}
      >
        Сохранить черновик занятия
      </button>
    </details>
  );
}
